import {Component, OnInit} from '@angular/core';
import {DialogService} from '../../services';

export interface IntercomUser {
    id: string;
    name: string;
}

@Component({
    selector: 'prism-intercom-user-selector-modal',
    templateUrl: './intercom-user-selector-modal.component.html',
    styleUrls: ['./intercom-user-selector-modal.component.scss']
})
export class IntercomUserSelectorModalComponent implements OnInit {
    users: IntercomUser[] = [
        {id: 'meghan', name: 'Meghan Ryan'},
        {id: 'ahytana', name: 'Ahytana Alencar'},
        {id: 'marie', name: 'Marie Maradiaga'},
        {id: 'patrick', name: 'Patrick Valdez'},
        {id: 'lindsey', name: 'Lindsey Cohen'},
        {id: 'taylor', name: 'Taylor Herzhauser'},
        {id: 'gl', name: 'Gerard Lynch'},
        {id: 'ml', name: 'Melissa Lynch'},
        {id: 'accounting', name: 'Evy Calidonio'},
        {id: 'camila', name: 'Camila Vera Tudela'},
        {id: 'gabrielle', name: 'Gabrielle Godinez'}
    ];
    selectedUser: IntercomUser | undefined;

    constructor(private dialogService: DialogService) {
    }

    ngOnInit() {
        // Pre-select previously selected user if available
        const savedUserId = localStorage.getItem('intercom-selected-user-id');
        if (savedUserId) {
            this.selectedUser = this.users.find(u => u.id === savedUserId);
        }
    }

    selectUser(user: IntercomUser) {
        this.selectedUser = user;
    }

    confirmSelection() {
        if (this.selectedUser) {
            localStorage.setItem('intercom-selected-user-id', this.selectedUser.id);
            localStorage.setItem('intercom-selected-user-name', this.selectedUser.name);
            this.dialogService.currentDialogRef.close(this.selectedUser);
        }
    }
}
